import { Skeleton } from '@/components/ui/skeleton';

const ACTIVITY_MARKER_CENTER_Y = 12;
const ACTIVITY_MARKER_SIZE_DEFAULT = 36;
const ACTIVITY_MARKER_SIZE_STATUS = 48;
const ACTIVITY_SKELETON_ITEMS = [
  { id: 'activity-skeleton-1', isStatus: true, showConnector: true },
  { id: 'activity-skeleton-2', isStatus: false, showConnector: true },
  { id: 'activity-skeleton-3', isStatus: false, showConnector: true },
  { id: 'activity-skeleton-4', isStatus: true, showConnector: true },
  { id: 'activity-skeleton-5', isStatus: false, showConnector: true },
  { id: 'activity-skeleton-6', isStatus: false, showConnector: true },
  { id: 'activity-skeleton-7', isStatus: true, showConnector: false },
] as const;

export function PurchaseOrderActivitySkeleton() {
  return (
    <div className='rounded-xl border bg-card p-6 shadow-sm'>
      <div className='space-y-6'>
        {ACTIVITY_SKELETON_ITEMS.map((item) => {
          const markerSize = item.isStatus
            ? ACTIVITY_MARKER_SIZE_STATUS
            : ACTIVITY_MARKER_SIZE_DEFAULT;

          return (
            <div className='relative pl-16' key={item.id}>
              {item.showConnector ? (
                <div className='absolute top-3 bottom-[-1.5rem] left-6 w-px -translate-x-1/2 bg-border' />
              ) : null}
              <div
                className='absolute left-6 flex -translate-x-1/2 items-center justify-center rounded-full border border-border bg-muted/50'
                style={{
                  height: `${markerSize}px`,
                  top: `${ACTIVITY_MARKER_CENTER_Y - markerSize / 2}px`,
                  width: `${markerSize}px`,
                }}
              >
                <Skeleton className='size-4 rounded-full' />
              </div>
              <div className='grid gap-3 md:grid-cols-[minmax(0,1fr)_140px] md:items-start'>
                <div className='space-y-3'>
                  <Skeleton className='h-5 w-4/5' />
                  <Skeleton className='h-4 w-1/3' />
                </div>
                <Skeleton className='h-4 w-28 justify-self-end' />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
